// @flow
import Cache from "../../utils/browser/Cache";
import { setCookie, clearCookie } from "../../utils/browser/Cookies";

import Locales from "../../i18n/Locales";

import type { Reducer } from "redux";
import type { I18nState } from "./types";
import type { ReduxAction } from "../types";

/**
 */
const updateLocale = (state: I18nState, locale: string) => {
  // set locale in cookie
  if (state.locales?.length > 1) {
    setCookie("locale", locale);
  } else {
    clearCookie("locale");
  }

  // clear cache because of cached contributions
  Cache.clear();

  return {
    ...state,
    locale,
  };
};

/**
 */
const setLocales = (
  state: I18nState,
  { locale, locales }: { locale: string, locales: Locales },
) => {
  // set locale in cookie
  if (state.locales.length > 1) {
    setCookie("locale", locale);
  } else {
    clearCookie("locale");
  }

  if (locale) {
    return {
      ...state,
      locales,
      locale,
    };
  }

  return {
    ...state,
    locales,
  };
};

const getDefaultLocale = () => {
  // $FlowIssue
  return globalThis.navigator?.language?.split("-")[0] || "en";
};

// REDUCER
const initialState: I18nState = {
  locales: new Locales(),
  locale: getDefaultLocale(),
};

/**
 * Form reducer
 */
export const I18nReducer: Reducer<I18nState, ReduxAction> = (
  state = initialState,
  action = void 0,
) => {
  if (!action) {
    return state;
  }

  switch (action.type) {
    case "SET_LOCALES":
      return setLocales(state, action.payload);

    case "UPDATE_LOCALE":
      return updateLocale(state, action.payload);

    default:
      return state;
  }
};
